// @ts-nocheck
import axios from "axios";
import { getCubaREST } from "@cuba-platform/react";
import { PersonGroupExt } from "../../../cuba/entities/base/base$PersonGroupExt";
import { Timeline } from "../../../cuba/entities/base/Timeline";
import { AssignedPerformancePlan } from "../../../cuba/entities/base/tsadv$AssignedPerformancePlan";
import { entitiesNames } from "../types";
import { restServices } from "../../../cuba/services";
import { rootStore } from "../../store";
import { getBlobUrl } from "../../util";

import {
  DEFAULT_DATE_TIME_PATTERN_WITHOUT_SECONDS,
  format,
} from "../../util/Date/Date";
import { FeedItemModel } from "../types/feed-item-model";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const qs = require("qs");

export const $api = axios.create({
  baseURL: process.env.REACT_APP_CUBA_URL + "v2/" || "/app/rest/",
  withCredentials: true,
});

$api.interceptors.request.use(
  (config) => {
    const token = getCubaREST()?.restApiToken;
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error),
);

type standParams = {
  view: string;
  limit?: string;
  offset?: string;
  sort?: string;
  filter?: any;
};
export const coderParamsNew = (param: standParams, conditions?: any) => {
  const params: any = {
    view: param.view,
    limit: param.limit,
    offset: param.offset,
    sort: param.sort,
  };
  if (conditions) {
    params.filter = JSON.stringify({
      conditions: conditions,
    });
  }
  return qs.stringify(params);
};

export const coderParams = (view: string, conditions: any) => {
  const params = {
    view: view,
    filter: JSON.stringify({
      conditions: conditions,
    }),
  };
  return qs.stringify(params);
};

export const getImage = async (groupId: string) => {
  if (!groupId) return null;

  const profile = await restServices.employeeService.personProfile(groupId);
  if (profile && profile.imageId) {
    const url = await getCubaREST()
      ?.getFile(profile.imageId)
      .then((value: Blob) => {
        return URL.createObjectURL(value);
      });
    return url;
  }
  return null;
};

export const getImageById = async (imageId: string) => {
  if (!imageId) return null;

  const url = await getCubaREST()
    ?.getFile(imageId)
    .then((value: Blob) => {
      return URL.createObjectURL(value);
    });
  return url;
};

type PaginationResult<T> = {
  count: number;
  result: T[];
  page: number;
  pageSize: number;
  hasNext: boolean;
};

export const fetchPortalHelper = async (
  page: number,
): Promise<PaginationResult<PersonGroupExt>> => {
  const response = await $api.post<PaginationResult<PersonGroupExt>>(
    "/services/kzm_NewEmployeeService/getBirthdayPeopleTodayList",
    {
      page: {
        pageNumber: page,
        pageSize: 10,
      },
    },
  );

  return response.data;
};

export enum ServiceName {
  portalHelperService = "tsadv_PortalHelperService",
  organizationHrUserService = "tsadv_OrganizationHrUserService",
  positionService = "tsadv_PositionService",
  learningService = "learningService",
}

enum PortalMethods {
  companiesForLoadDictionary = "getCompaniesForLoadDictionary",
}

enum OrganizationMethods {
  getHrUsersForPerson = "getHrUsersForPerson",
}

enum PositionMethods {
  getManager = "getManager",
}

enum QueryMethods {
  assignedPerformancePlan = "tsadv$AssignedPerformancePlan",
}

enum kpiServicesQuery {
  kpiEditPage = "kpiEditPage",
}

export const fetchPortalNews = async (
  personGroupId: string,
): Promise<FeedItemModel[]> => {
  const companiesForLoadDictionary = async (personGroupId: string) => {
    const { data } = await $api.get<string[]>(
      `services/${ServiceName.portalHelperService}/${PortalMethods.companiesForLoadDictionary}`,
      { params: { personGroupId } },
    );
    const res = await getData(data);
    return withTranslate(res);
  };
  const getData = async (companies: string[]) => {
    const conditions = [
      {
        property: "company.id",
        operator: "in",
        value: companies,
      },
      {
        property: "isPublished",
        operator: "=",
        value: "true",
      },
    ];
    const encodedParamsCompany = coderParamsNew(
      { view: "timeline.edit", sort: "-createTs" },
      conditions,
    );
    const { data } = await $api.get<Timeline[]>(
      `/entities/${entitiesNames.timeline}/search?${encodedParamsCompany}`,
    );
    return data;
  };
  const withTranslate = (timelinesWithCount: Timeline[]) => {
    const userLang =
      (rootStore.userInfo?.language?.length || 0) > 0 &&
      rootStore.userInfo?.language?.[0]?.toUpperCase() +
        rootStore?.userInfo?.language?.[1];
    const language = userLang || "Ru";
    return timelinesWithCount.map((tl) => {
      return {
        id: tl.id,
        title: tl["newsTopic" + language],
        text: tl["newsText" + language],
        date: format(tl.dateTo, DEFAULT_DATE_TIME_PATTERN_WITHOUT_SECONDS),
        img: tl["image" + language]
          ? getBlobUrl(tl["image" + language].id)
          : undefined,
        url: tl["url" + language],
      };
    });
  };

  return await companiesForLoadDictionary(personGroupId);
};

export const fetchLinearManager = async (positionGroupId: string) => {
  const { data } = await $api.get(
    `/services/${ServiceName.positionService}/${PositionMethods.getManager}`,
    { params: { positionGroupId } },
  );
  return data;
};

export const fetchLinearManagerPersonGroup = async (
  personGroupId: string,
  roleCode = "MANAGER",
) => {
  const { data } = await $api.get(
    `/services/${ServiceName.organizationHrUserService}/${OrganizationMethods.getHrUsersForPerson}`,
    {
      params: {
        personGroupId,
        roleCode,
      },
    },
  );
  return data;
};
export const getAssignedPerformancePlan = async (appId: string) => {
  const { data } = await $api.get<AssignedPerformancePlan[]>(
    `/queries/${QueryMethods.assignedPerformancePlan}/${kpiServicesQuery.kpiEditPage}`,
    { params: { appId } },
  );
  return data;
};
